import deepmerge from 'deepmerge';

const camelizeRE = /-(\w)/g;
export const camelize = (str) => (str
  ? str.charAt(0).toUpperCase() + str.slice(1).replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''))
  : ''
);

const hyphenateRE = /\B([A-Z])/g;
export const hyphenate = (str) => (str ? str.replace(hyphenateRE, '-$1').toLowerCase() : '');

export const convertName = (string) => {
  const camelName = camelize(string);
  const kebabName = hyphenate(string);

  return {
    basename: string,
    camelName,
    kebabName,
  };
};

export const overwriteMerge = (destinationArray, sourceArray) => sourceArray;

export const combineMerge = (target, source, options) => {
  const destination = target.slice();

  source.forEach((item, index) => {
    if (typeof destination[index] === 'undefined') {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      destination[index] = deepmerge(target[index], item, options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};
